import { defineMessages } from 'react-intl';

export const messages: {
	ai_debugger_icon_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_original_query_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_transformed_query_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_detected_intent_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_trace_id_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_answer_trace_id_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_model_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_sources_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_cached_answer_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_copy_button_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_copy_button_copied_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_tab_request_overview: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_tab_raw_search_results: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_tab_ranked_search_results: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_tab_plugin_invocations: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_tab_raw_json: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_copy_trace_id_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_trace_id_copied_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_splunk_link_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_tab_els_overview: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_intent_detection_trace_id_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_intent_detection_trace_id_diverged: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_copy_intent_detection_trace_id_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_original_intent_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_els_trace_id_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_detection_metadata_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_detection_method_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_detection_model_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_detection_latency_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_detection_cache_hit_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_prefilter_entities_subheading_with_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_prefilter_entity_confidence_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_prefilter_entity_clarification_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_prefilter_entity_mention_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_prefilter_entity_type_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_persons_subheading_with_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_entity_id_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_person_account_id_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_person_email_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_person_job_title_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_person_department_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_person_organization_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_person_location_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_person_zone_info_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_els_empty_state: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_expand_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_collapse_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_success_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_failed_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_search_results_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_ranked_documents_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_tab_orchestration_overview: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_tab_loop: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_orchestration_loop_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_orchestration_loop_with_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_orchestration_minions_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_no_orchestration_data: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_minion_input_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_minion_output_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_execution_duration: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_execution_duration_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_minion_name_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_disabled: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_minion_extra_info_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_no_plugins_invoked: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_teamwork_unnamed_team: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_teamwork_members_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_teamwork_state: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_teamwork_creator: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_teamwork_show_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_teamwork_hide_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_author_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_teamwork_document_updated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_page_search_space: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_page_search_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_function_results_count: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_raw_search_results_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_table_url_header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_table_doc_index_header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_no_raw_search_results: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_ranked_search_results_heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_table_chunk_id_header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_table_chunk_score_header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_table_chunk_rank_header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_no_ranked_search_results: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_unable_to_match_chunks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_debugger_modal_plugins_invoked_subheading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prompt_override_button_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prompt_override_modal_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prompt_override_custom_prompt_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prompt_override_textarea_placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prompt_override_help_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prompt_override_cancel_button: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	prompt_override_save_button: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ai_debugger_icon_label: {
		id: 'search_ai.ai_debugger_icon_label',
		defaultMessage: 'Debugger',
		description:
			'Accessible label for the debugger icon button that opens the SAIN debugging panel in the search AI interface.',
	},
	ai_debugger_modal_title: {
		id: 'search_ai.ai_debugger_modal_title',
		defaultMessage: 'SAIN Debugging Panel',
		description:
			'Title shown at the top of the SAIN debugging modal dialog used by developers to inspect AI search request details.',
	},
	ai_debugger_modal_original_query_subheading: {
		id: 'search_ai.ai_debugger_modal_original_query_subheading',
		defaultMessage: 'Original Query',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the original unmodified search query submitted by the user.',
	},
	ai_debugger_modal_transformed_query_subheading: {
		id: 'search_ai.ai_debugger_modal_transformed_query_subheading',
		defaultMessage: 'Transformed Query',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the AI-transformed version of the search query.',
	},
	ai_debugger_modal_detected_intent_subheading: {
		id: 'search_ai.ai_debugger_modal_final_routing_intent_subheading',
		defaultMessage: 'Final Routing Intent',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the final routing intent (the intent classification the query was ultimately routed to) chosen by the AI for the user query.',
	},
	ai_debugger_modal_trace_id_subheading: {
		id: 'search_ai.ai_debugger_modal_trace_id_subheading',
		defaultMessage: 'Trace ID',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the trace ID used to identify and trace the AI search request.',
	},
	ai_debugger_modal_answer_trace_id_subheading: {
		id: 'search_ai.ai_debugger_modal_answer_trace_id_subheading',
		defaultMessage: 'Answer Trace ID',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the trace ID of the AI answer request, labelled "Answer" to differentiate it from the Intent Detection Trace ID.',
	},
	ai_debugger_modal_model_subheading: {
		id: 'search_ai.ai_debugger_modal_model_subheading',
		defaultMessage: 'Answer Generation Model',
		description:
			'Sub-heading shown in the debugging panel for the section displaying which AI model was used to generate the answer.',
	},
	ai_debugger_modal_sources_subheading: {
		id: 'search_ai.ai_debugger_modal_sources_subheading',
		defaultMessage: 'Sources',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the source documents used to generate the AI answer.',
	},
	ai_debugger_modal_cached_answer_subheading: {
		id: 'search_ai.ai_debugger_modal_cached_answer_subheading',
		defaultMessage: 'Cached answer',
		description:
			'Sub-heading shown in the debugging panel for the section indicating whether the AI answer was served from cache.',
	},
	ai_debugger_modal_copy_button_text: {
		id: 'search_ai.ai_debugger_modal_copy_button_text',
		defaultMessage: 'Copy JSON',
		description:
			'Text shown on the button in the debugging panel that copies the full request or response data as a JSON string to the clipboard.',
	},
	ai_debugger_modal_copy_button_copied_text: {
		id: 'search_ai.ai_debugger_modal_copy_button_copied_text',
		defaultMessage: 'JSON Copied',
		description: 'Text for copy button after JSON is copied',
	},
	ai_debugger_modal_tab_request_overview: {
		id: 'search_ai.ai_debugger_modal_tab_request_overview',
		defaultMessage: 'Request Overview',
		description:
			'Label for the tab in the SAIN debugging modal that displays a high-level overview of the AI search request.',
	},
	ai_debugger_modal_tab_raw_search_results: {
		id: 'search_ai.ai_debugger_modal_tab_raw_search_results',
		defaultMessage: 'Raw Search Results',
		description:
			'Label for the tab in the SAIN debugging modal that shows the raw, unranked search results returned before AI processing.',
	},
	ai_debugger_modal_tab_ranked_search_results: {
		id: 'search_ai.ai_debugger_modal_tab_ranked_search_results',
		defaultMessage: 'Ranked Search Results',
		description:
			'Label for the tab in the SAIN debugging modal that shows the search results after AI reranking.',
	},
	ai_debugger_modal_tab_plugin_invocations: {
		id: 'search_ai.ai_debugger_modal_tab_plugin_invocations',
		defaultMessage: 'Plugin Invocations',
		description:
			'Label for the tab in the SAIN debugging modal that lists all plugin invocations made during the AI search request.',
	},
	ai_debugger_modal_tab_raw_json: {
		id: 'search_ai.ai_debugger_modal_tab_raw_json',
		defaultMessage: 'Raw JSON',
		description:
			'Label for the tab in the SAIN debugging modal that displays the full raw JSON payload of the AI search response.',
	},
	ai_debugger_modal_copy_trace_id_label: {
		id: 'search_ai.ai_debugger_modal_copy_trace_id_label',
		defaultMessage: 'Copy Trace ID',
		description:
			'Accessible label for the button in the debugging panel that copies the trace ID to the clipboard for use in diagnostics.',
	},
	ai_debugger_modal_trace_id_copied_text: {
		id: 'search_ai.ai_debugger_modal_trace_id_copied_text',
		defaultMessage: 'Trace ID copied',
		description:
			'Confirmation text shown after the user successfully copies the trace ID to the clipboard in the debugging panel.',
	},
	ai_debugger_modal_splunk_link_label: {
		id: 'search_ai.ai_debugger_modal_splunk_link_label',
		defaultMessage: 'Splunk',
		description:
			'Label for a link in the debugging panel that opens Splunk logs filtered to the associated trace ID.',
	},
	ai_debugger_modal_tab_els_overview: {
		id: 'search_ai.ai_debugger_modal_tab_els_overview',
		defaultMessage: 'ELS Overview',
		description:
			'Label for the tab in the SAIN debugging modal that shows Entity Linking Service (ELS) details for a person-intent query, including detected entities and person profiles.',
	},
	ai_debugger_modal_intent_detection_trace_id_subheading: {
		id: 'search_ai.ai_debugger_modal_intent_detection_trace_id_subheading',
		defaultMessage: 'Intent Detection Trace ID',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the trace ID of the intent-detection request, which can differ from the main answer trace ID.',
	},
	ai_debugger_modal_intent_detection_trace_id_diverged: {
		id: 'search_ai.ai_debugger_modal_intent_detection_trace_id_diverged',
		defaultMessage: 'Differs from the request Trace ID above',
		description:
			'Notice shown in the debugging panel when the intent-detection trace ID is different from the main request trace ID, so the developer knows to trace them separately.',
	},
	ai_debugger_modal_copy_intent_detection_trace_id_label: {
		id: 'search_ai.ai_debugger_modal_copy_intent_detection_trace_id_label',
		defaultMessage: 'Copy Intent Detection Trace ID',
		description:
			'Accessible label for the button in the debugging panel that copies the intent-detection trace ID to the clipboard.',
	},
	ai_debugger_modal_original_intent_subheading: {
		id: 'search_ai.ai_debugger_modal_original_intent_prediction_subheading',
		defaultMessage: 'Original Intent Prediction',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the intent as originally predicted/classified, before any downstream fallback or override was applied.',
	},
	ai_debugger_modal_els_trace_id_subheading: {
		id: 'search_ai.ai_debugger_modal_els_trace_id_subheading',
		defaultMessage: 'ELS Trace ID',
		description:
			'Sub-heading shown in the debugging panel for the section displaying the trace ID of the Entity Linking Service (ELS) request.',
	},
	ai_debugger_modal_detection_metadata_subheading: {
		id: 'search_ai.ai_debugger_modal_detection_metadata_subheading',
		defaultMessage: 'Detection Metadata',
		description:
			'Sub-heading shown in the debugging panel for the section displaying metadata about how the intent was detected (method, model, latency, cache).',
	},
	ai_debugger_modal_detection_method_label: {
		id: 'search_ai.ai_debugger_modal_detection_method_label',
		defaultMessage: 'Method',
		description:
			'Label for the intent-detection method (for example LLM) in the detection metadata section of the debugging panel.',
	},
	ai_debugger_modal_detection_model_label: {
		id: 'search_ai.ai_debugger_modal_detection_model_label',
		defaultMessage: 'Model',
		description:
			'Label for the model used for intent detection in the detection metadata section of the debugging panel.',
	},
	ai_debugger_modal_detection_latency_label: {
		id: 'search_ai.ai_debugger_modal_detection_latency_label',
		defaultMessage: 'Latency (ms)',
		description:
			'Label for the intent-detection latency in milliseconds in the detection metadata section of the debugging panel.',
	},
	ai_debugger_modal_detection_cache_hit_label: {
		id: 'search_ai.ai_debugger_modal_detection_cache_hit_label',
		defaultMessage: 'Cache Hit',
		description:
			'Label indicating whether the intent-detection result was served from cache in the detection metadata section of the debugging panel.',
	},
	ai_debugger_modal_prefilter_entities_subheading_with_count: {
		id: 'search_ai.ai_debugger_modal_prefilter_entities_subheading_with_count',
		defaultMessage: 'Prefilter Entities ({count})',
		description:
			'Sub-heading (including the number of entities) shown in the debugging panel for the section listing entities resolved by the Entity Linking Service (ELS) prefilter step.',
	},
	ai_debugger_modal_prefilter_entity_confidence_label: {
		id: 'search_ai.ai_debugger_modal_prefilter_entity_confidence_label',
		defaultMessage: 'Confidence',
		description:
			'Label for the confidence score of a prefilter entity in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_prefilter_entity_clarification_label: {
		id: 'search_ai.ai_debugger_modal_prefilter_entity_clarification_label',
		defaultMessage: 'Clarification Level',
		description:
			'Label for the clarification level of a prefilter entity in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_prefilter_entity_mention_label: {
		id: 'search_ai.ai_debugger_modal_prefilter_entity_mention_label',
		defaultMessage: 'Mention',
		description:
			'Label for the text mention that a prefilter entity was resolved from, in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_prefilter_entity_type_label: {
		id: 'search_ai.ai_debugger_modal_prefilter_entity_type_label',
		defaultMessage: 'Entity Type',
		description:
			'Label for the type of a prefilter entity (for example PERSON) in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_persons_subheading_with_count: {
		id: 'search_ai.ai_debugger_modal_persons_subheading_with_count',
		defaultMessage: 'Persons ({count})',
		description:
			'Sub-heading (including the number of persons) shown in the debugging panel for the section listing the person profiles returned for a person-intent query.',
	},
	ai_debugger_modal_entity_id_label: {
		id: 'search_ai.ai_debugger_modal_entity_id_label',
		defaultMessage: 'ID',
		description:
			'Label for the identifier of a prefilter entity in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_person_account_id_label: {
		id: 'search_ai.ai_debugger_modal_person_account_id_label',
		defaultMessage: 'Account ID',
		description:
			'Label for the account ID of a person profile in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_person_email_label: {
		id: 'search_ai.ai_debugger_modal_person_email_label',
		defaultMessage: 'Email',
		description:
			'Label for the email address of a person profile in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_person_job_title_label: {
		id: 'search_ai.ai_debugger_modal_person_job_title_label',
		defaultMessage: 'Job Title',
		description:
			'Label for the job title of a person profile in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_person_department_label: {
		id: 'search_ai.ai_debugger_modal_person_department_label',
		defaultMessage: 'Department',
		description:
			'Label for the department of a person profile in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_person_organization_label: {
		id: 'search_ai.ai_debugger_modal_person_organization_label',
		defaultMessage: 'Organization',
		description:
			'Label for the organization of a person profile in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_person_location_label: {
		id: 'search_ai.ai_debugger_modal_person_location_label',
		defaultMessage: 'Location',
		description:
			'Label for the location of a person profile in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_person_zone_info_label: {
		id: 'search_ai.ai_debugger_modal_person_zone_info_label',
		defaultMessage: 'Zone Info',
		description:
			'Label for the time zone info of a person profile in the ELS Overview section of the debugging panel.',
	},
	ai_debugger_modal_els_empty_state: {
		id: 'search_ai.ai_debugger_modal_els_empty_state',
		defaultMessage: 'No ELS data available for this request.',
		description:
			'Message shown in the ELS Overview tab of the debugging panel when no Entity Linking Service data is available for the request.',
	},
	ai_debugger_modal_expand_label: {
		id: 'search_ai.ai_debugger_modal_expand_label',
		defaultMessage: 'Expand',
		description:
			'Accessible label for the expand button in the debugging panel that reveals additional detail for a collapsed section.',
	},
	ai_debugger_modal_collapse_label: {
		id: 'search_ai.ai_debugger_modal_collapse_label',
		defaultMessage: 'Collapse',
		description:
			'Accessible label for the collapse button in the debugging panel that hides the expanded detail of a section.',
	},
	ai_debugger_modal_success_label: {
		id: 'search_ai.ai_debugger_modal_success_label',
		defaultMessage: 'Success',
		description:
			'Status label shown in the debugging panel to indicate that a plugin invocation or request step completed successfully.',
	},
	ai_debugger_modal_failed_label: {
		id: 'search_ai.ai_debugger_modal_failed_label',
		defaultMessage: 'Failed',
		description:
			'Status label shown in the debugging panel to indicate that a plugin invocation or request step failed.',
	},
	ai_debugger_modal_search_results_heading: {
		id: 'search_ai.ai_debugger_modal_search_results_heading',
		defaultMessage: 'Search Results ({count})',
		description: 'Heading for search results section with count',
	},
	ai_debugger_modal_ranked_documents_heading: {
		id: 'search_ai.ai_debugger_modal_ranked_documents_heading',
		defaultMessage: 'Ranked Documents ({count})',
		description: 'Heading for ranked documents section with count',
	},
	ai_debugger_modal_tab_orchestration_overview: {
		id: 'search_ai.ai_debugger_modal_tab_orchestration_overview',
		defaultMessage: 'Orchestration Overview',
		description:
			'Label for the tab in the SAIN debugging modal that displays a high-level overview of the AI orchestration process.',
	},
	ai_debugger_modal_tab_loop: {
		id: 'search_ai.ai_debugger_modal_tab_loop',
		defaultMessage: 'Loop {number}',
		description:
			'Label for a numbered loop tab in the orchestration debugging panel. The placeholder {number} is substituted with the loop index.',
	},
	ai_debugger_modal_orchestration_loop_heading: {
		id: 'search_ai.ai_debugger_modal_orchestration_loop_heading',
		defaultMessage: 'Loop {number}',
		description:
			'Heading shown at the top of a loop section in the orchestration debugging panel. The placeholder {number} is substituted with the loop index.',
	},
	ai_debugger_modal_orchestration_loop_with_count: {
		id: 'search_ai.ai_debugger_modal_orchestration_loop_with_count',
		defaultMessage: 'Loop {number} - {count} {count, plural, one {minion} other {minions}}',
		description: 'Heading for orchestration loop with minion count',
	},
	ai_debugger_modal_orchestration_minions_count: {
		id: 'search_ai.ai_debugger_modal_orchestration_minions_count',
		defaultMessage: '{count} {count, plural, one {minion} other {minions}}',
		description:
			'Text shown in the orchestration debugging panel indicating how many minion agents ran in a loop. The placeholder {count} controls the plural form (one vs. other).',
	},
	ai_debugger_modal_no_orchestration_data: {
		id: 'search_ai.ai_debugger_modal_no_orchestration_data',
		defaultMessage: 'No minion outputs to show.',
		description: 'Text shown when no minion outputs are available',
	},
	ai_debugger_modal_minion_input_label: {
		id: 'search_ai.ai_debugger_modal_minion_input_label',
		defaultMessage: 'Input',
		description:
			'Label shown next to the input field in the minion detail section of the orchestration debugging panel.',
	},
	ai_debugger_modal_minion_output_label: {
		id: 'search_ai.ai_debugger_modal_minion_output_label',
		defaultMessage: 'Output',
		description:
			'Label shown next to the output field in the minion detail section of the orchestration debugging panel.',
	},
	ai_debugger_modal_execution_duration: {
		id: 'search_ai.ai_debugger_modal_execution_duration',
		defaultMessage: '{duration}ms',
		description:
			'Text displaying the execution duration in milliseconds in the debugging panel. The placeholder {duration} is substituted with the numeric duration value.',
	},
	ai_debugger_modal_execution_duration_label: {
		id: 'search_ai.ai_debugger_modal_execution_duration_label',
		defaultMessage: 'Duration',
		description:
			'Column or field label in the debugging panel for the execution duration of a plugin invocation or minion step.',
	},
	ai_debugger_modal_minion_name_label: {
		id: 'search_ai.ai_debugger_modal_minion_name_label',
		defaultMessage: 'Minion Name',
		description:
			'Column header label in the orchestration debugging panel table that identifies the name of each minion agent.',
	},
	ai_debugger_modal_disabled: {
		id: 'search_ai.ai_debugger_modal_disabled',
		defaultMessage: 'disabled',
		description: 'Text shown when a value is not available',
	},
	ai_debugger_modal_minion_extra_info_label: {
		id: 'search_ai.ai_debugger_modal_plugin_output_label',
		defaultMessage: 'Extra Info',
		description:
			'Label for the extra info section in the minion detail view of the orchestration debugging panel, showing additional plugin output data.',
	},
	ai_debugger_modal_no_plugins_invoked: {
		id: 'search_ai.ai_debugger_modal_no_plugins_invoked',
		defaultMessage: 'No additional plugins invoked.',
		description: 'Text shown when no additional plugins were invoked',
	},
	ai_debugger_modal_teamwork_unnamed_team: {
		id: 'search_ai.ai_debugger_modal_teamwork_unnamed_team',
		defaultMessage: 'Unnamed Team',
		description:
			'Fallback team name shown in the debugging panel when a teamwork result does not have a display name.',
	},
	ai_debugger_modal_teamwork_members_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_members_count',
		defaultMessage: 'Members: {count}',
		description:
			'Text shown in the teamwork card in the debugging panel displaying the number of members. The placeholder {count} is substituted with the member count.',
	},
	ai_debugger_modal_teamwork_state: {
		id: 'search_ai.ai_debugger_modal_teamwork_state',
		defaultMessage: 'State: {state}',
		description:
			'Text shown in the teamwork card in the debugging panel displaying the team state. The placeholder {state} is substituted with the current state value.',
	},
	ai_debugger_modal_teamwork_creator: {
		id: 'search_ai.ai_debugger_modal_teamwork_creator',
		defaultMessage: 'Creator: {creator}',
		description:
			'Text shown in the teamwork card in the debugging panel displaying the team creator. The placeholder {creator} is substituted with the creator name.',
	},
	ai_debugger_modal_teamwork_show_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_show_count',
		defaultMessage: 'Show {count} {count, plural, one {member} other {members}}',
		description:
			'Text on the button that expands a collapsed member list in the debugging panel. The placeholder {count} controls the plural form (one vs. other).',
	},
	ai_debugger_modal_teamwork_hide_count: {
		id: 'search_ai.ai_debugger_modal_teamwork_hide_count',
		defaultMessage: 'Hide {count} {count, plural, one {member} other {members}}',
		description:
			'Text on the button that collapses an expanded member list in the debugging panel. The placeholder {count} controls the plural form (one vs. other).',
	},
	ai_debugger_modal_author_label: {
		id: 'search_ai.ai_debugger_modal_author_label',
		defaultMessage: 'Author: {author}',
		description:
			'Text shown in the document card in the debugging panel indicating the document author. The placeholder {author} is substituted with the author name.',
	},
	ai_debugger_modal_teamwork_document_updated: {
		id: 'search_ai.ai_debugger_modal_teamwork_document_updated',
		defaultMessage: 'Updated: {date}',
		description:
			'Text shown in the document card in the debugging panel indicating when the document was last updated. The placeholder {date} is substituted with the date string.',
	},
	ai_debugger_modal_page_search_space: {
		id: 'search_ai.ai_debugger_modal_page_search_space',
		defaultMessage: 'Space: {space}',
		description:
			'Text shown in the page search card in the debugging panel displaying the Confluence space name. The placeholder {space} is substituted with the space name.',
	},
	ai_debugger_modal_page_search_count: {
		id: 'search_ai.ai_debugger_modal_page_search_count',
		defaultMessage: '{count} {count, plural, one {page} other {pages}} found',
		description:
			'Text shown in the page search card in the debugging panel reporting the number of pages found. The placeholder {count} controls the plural form (one vs. other).',
	},
	ai_debugger_modal_function_results_count: {
		id: 'search_ai.ai_debugger_modal_function_results_count',
		defaultMessage: 'Function Results ({count})',
		description:
			'Section heading in the plugin invocations debugging panel showing the number of function results returned. The placeholder {count} is substituted with the result count.',
	},
	ai_debugger_modal_raw_search_results_heading: {
		id: 'search_ai.ai_debugger_modal_raw_search_results_heading',
		defaultMessage:
			'{count, plural, one {Raw Search Result ({count})} other {Raw Search Results ({count})}}',
		description: 'Heading for raw search results section with count, pluralized',
	},
	ai_debugger_modal_table_url_header: {
		id: 'search_ai.ai_debugger_modal_table_url_header',
		defaultMessage: 'Document URL',
		description:
			'Column header label in the search results table in the debugging panel for the document URL column.',
	},
	ai_debugger_modal_table_doc_index_header: {
		id: 'search_ai.ai_debugger_modal_table_doc_index_header',
		defaultMessage: '#',
		description: 'Table header for document index/ranking column',
	},
	ai_debugger_modal_no_raw_search_results: {
		id: 'search_ai.ai_debugger_modal_no_raw_search_results',
		defaultMessage: 'No raw search results available.',
		description: 'Text shown when no raw search results are available',
	},
	ai_debugger_modal_ranked_search_results_heading: {
		id: 'search_ai.ai_debugger_modal_ranked_search_results_heading',
		defaultMessage:
			'{count, plural, one {Ranked Document with Chunks ({count})} other {Ranked Documents with Chunks ({count})}}',
		description: 'Heading for ranked search results section with count, pluralized',
	},
	ai_debugger_modal_table_chunk_id_header: {
		id: 'search_ai.ai_debugger_modal_table_chunk_id_header',
		defaultMessage: 'Chunk ID',
		description:
			'Column header label in the search results table in the debugging panel for the document chunk identifier column.',
	},
	ai_debugger_modal_table_chunk_score_header: {
		id: 'search_ai.ai_debugger_modal_table_chunk_score_header',
		defaultMessage: 'Score',
		description:
			'Column header label in the search results table in the debugging panel for the relevance score assigned to each document chunk.',
	},
	ai_debugger_modal_table_chunk_rank_header: {
		id: 'search_ai.ai_debugger_modal_table_chunk_rank_header',
		defaultMessage: 'Rank',
		description:
			'Column header label in the search results table in the debugging panel for the rank position of each document chunk.',
	},
	ai_debugger_modal_no_ranked_search_results: {
		id: 'search_ai.ai_debugger_modal_no_ranked_search_results',
		defaultMessage: 'No ranked search results available.',
		description: 'Text shown when no ranked search results are available',
	},
	ai_debugger_modal_unable_to_match_chunks: {
		id: 'search_ai.ai_debugger_modal_unable_to_match_chunks',
		defaultMessage: 'Unable to match chunks',
		description: 'Text shown when unable to match chunks for a document',
	},
	ai_debugger_modal_plugins_invoked_subheading: {
		id: 'search_ai.ai_debugger_modal_plugins_invoked_subheading',
		defaultMessage: 'Plugins Invoked',
		description:
			'Sub-heading shown in the debugging panel for the section listing all plugins that were invoked during the AI search request.',
	},
	prompt_override_button_label: {
		id: 'search_ai.prompt_override_button_label',
		defaultMessage: 'Prompt override',
		description:
			'Text shown on the button that opens the prompt override modal, allowing developers to inject a custom system prompt for debugging purposes.',
	},
	prompt_override_modal_title: {
		id: 'search_ai.prompt_override_modal_title',
		defaultMessage: 'Custom System Prompt Override',
		description:
			'Title shown at the top of the modal dialog that allows developers to enter a custom system prompt override for AI debugging.',
	},
	prompt_override_custom_prompt_label: {
		id: 'search_ai.prompt_override_custom_prompt_label',
		defaultMessage: 'Custom Prompt:',
		description:
			'Label shown above the text area in the prompt override modal where developers can enter a custom system prompt for AI debugging.',
	},
	prompt_override_textarea_placeholder: {
		id: 'search_ai.prompt_override_textarea_placeholder',
		defaultMessage: 'Enter your custom system prompt here...',
		description: 'Placeholder text for custom prompt text area',
	},
	prompt_override_help_text: {
		id: 'search_ai.prompt_override_help_text',
		defaultMessage:
			'This prompt will override the default system prompt for AI requests during this session.',
		description: 'Help text explaining the prompt override functionality',
	},
	prompt_override_cancel_button: {
		id: 'search_ai.prompt_override_cancel_button',
		defaultMessage: 'Cancel',
		description: 'Text for cancel button in prompt override modal',
	},
	prompt_override_save_button: {
		id: 'search_ai.prompt_override_save_button',
		defaultMessage: 'Save',
		description: 'Text for save button in prompt override modal',
	},
});
